RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    views.SecondaryNavigation = Marionette.CompositeView.extend({
        childEvents: {
            activated: 'onItemActivated'
        },
        modelEvents: {
            change: 'render'
        },

        tagName: 'nav',
        childViewContainer: 'ul',
        attributes: {
            role: 'navigation'
        },

        childView: views.SecondaryNavigationItem,
        className: 'navbar navbar-white navbar-default navbar-fixed',
        template: '#shellSecondaryNavigationTemplate',

        initialize: function (options) {

            const me = this;
            RivalIQ.state.utils.bindStateEvents(me, options);
            me.updateDocumentTitleForActiveModel();
        },

        childViewOptions: function (model) {

            const me = this;
            const activeModel = me.model.get('activeModel');

            const result = _.defaults({
                active: (activeModel === model)
            }, model.get('viewOptions'));

            return result;
        },

        templateHelpers: function () {

            const me = this;
            const model = me.model;
            const activeModel = model.get('activeModel');

            const result = {
                s: s,
                active: activeModel.toJSON()
            };

            return result;
        },

        filter: function (item) {

            const itm = item.toJSON();
            return (_.isUndefined(itm.display) || _.result(itm, 'display'));
        },

        onItemActivated: function (view) {

            const me = this;
            const activeModel = view.model;

            _.defer(function () {
                me.model.set({
                    activeModel: activeModel
                });
                me.updateDocumentTitleForActiveModel();
            });
        },

        updateDocumentTitleForActiveModel: function () {

            const me = this;
            const activeModel = me.model.get('activeModel');

            if (!activeModel) {

                return;
            }

            const navigation = (activeModel.get('navigation') || {});
            const title = _.result(navigation, 'title');

            App.execute('set:document:title', title);
        }
    });

}, window.s);
